export function getScrollParent(node: HTMLElement | null): HTMLElement | null {
  if (!node) {
    return null;
  }

  if (node.scrollHeight > node.clientHeight) {
    return node;
  } else {
    return getScrollParent(node.parentElement);
  }
}

export function getNearestScrollChild(node: HTMLElement | null): HTMLElement | null {
  const queue = [node];
  while (queue.length) {
    const current = queue.shift();
    if (!current) {
      return null;
    }

    if (current.scrollHeight > current.clientHeight) {
      return current;
    }

    queue.push(...(Array.from(current.children) as HTMLElement[]));
  }

  return null;
}
